<div class="modal-header">
  <h5 class="modal-title">Archive Item</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label class="form-label">Reason</label>
    <textarea class="form-control" 
              [(ngModel)]="reason" 
              maxlength="500" 
              rows="4"
              placeholder="Enter reason for archiving"></textarea>
  </div>
</div>

<div class="modal-footer">
  <button *ngIf="!isLoading" 
          type="button" 
          class="btn btn-success" 
          [disabled]="reason.length == 0"
          (click)="archiveItem()">
    Archive
  </button>

  <button *ngIf="isLoading" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Archiving...
  </button>
</div>